import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import soloFilledIcon from "assets/Solo_filled.svg";
import talkFilledIcon from "assets/talk_filled.svg";
import sentimentNeutralIcon from "assets/sentiment_neutral.svg";
import checkCircleIcon from "assets/Check_circle.svg";
import commentsIcon from "assets/Comments.svg";
import targetIcon from "assets/Target.svg";
import infoIcon from "assets/Info.svg";
import writeDownIcon from "assets/WriteDown.svg";
import { colors, constants } from "utils";

const LevelUpTipIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.1902 0.0107422C20.9674 0.061358 21.727 0.287961 22.4041 0.675781L33.4519 7.00293H33.4539C35.0241 7.90202 36.0007 9.57866 36.0007 11.3779V24.0303L35.989 24.3662C35.8761 26.0362 34.9271 27.5624 33.4539 28.4053L22.4041 34.7324L22.1091 34.8887C21.4111 35.2294 20.6389 35.4091 19.8572 35.4092L19.5222 35.3975C18.7445 35.3468 17.9852 35.1201 17.3083 34.7324L6.25854 28.4053C4.68828 27.5063 3.71183 25.8295 3.71167 24.0303V11.3779C3.71174 9.69102 4.57019 8.11222 5.97144 7.18066L6.25854 7.00293L17.3083 0.675781C18.082 0.233927 18.9648 0 19.8572 0L20.1902 0.0107422ZM19.8572 2C19.3133 2 18.7727 2.14238 18.3015 2.41113L7.25269 8.73828L7.25171 8.73926C6.35884 9.25076 5.78662 10.1762 5.71851 11.1768L5.71167 11.3779V24.0303C5.71183 25.1067 6.29911 26.1244 7.25171 26.6699H7.25269L18.3025 32.9971L18.4812 33.0918C18.9058 33.2992 19.3782 33.4092 19.8572 33.4092C20.4026 33.4091 20.9406 33.2645 21.4099 32.9961L32.4597 26.6699H32.4607C33.4135 26.1249 34.0006 25.1076 34.0007 24.0303V11.3779C34.0007 10.3013 33.4125 9.28481 32.4597 8.73926V8.73828H32.4587L21.4099 2.41211C20.9409 2.14346 20.4028 2.00008 19.8572 2Z" fill="#BC165D" />
    <path d="M20.3252 5.13574C20.8989 5.17239 21.4601 5.33646 21.96 5.61719L30.1182 10.1992H30.1191C31.2785 10.8502 31.9998 12.0644 32 13.3672V22.5293L31.9912 22.7725C31.9079 23.9819 31.2071 25.0868 30.1191 25.6973L21.96 30.2793L21.7422 30.3926C21.2267 30.6394 20.6565 30.7685 20.0791 30.7686L19.832 30.7607C19.3397 30.7293 18.8575 30.6045 18.415 30.3926L18.1973 30.2793L10.0381 25.6973C8.87861 25.0462 8.15723 23.8322 8.15723 22.5293V13.3672C8.15743 12.146 8.79091 11.0027 9.8252 10.3281L10.0381 10.1992L18.1973 5.61719C18.7684 5.29732 19.4203 5.12795 20.0791 5.12793L20.3252 5.13574ZM20.0791 6.62793C19.6756 6.62795 19.2768 6.73291 18.9307 6.92676L18.9297 6.92578L10.7725 11.5068C10.0734 11.8993 9.65745 12.6209 9.65723 13.3672V22.5293C9.65723 23.2757 10.0734 23.997 10.7725 24.3896L18.9316 28.9717C19.2758 29.165 19.6735 29.2685 20.0791 29.2686C20.433 29.2685 20.7813 29.1886 21.0938 29.0391L21.2256 28.9707L29.3848 24.3896L29.5127 24.3125C30.1346 23.9074 30.5 23.2298 30.5 22.5293V13.3672C30.4998 12.6248 30.0879 11.9075 29.3955 11.5137L29.3838 11.5068L21.2246 6.92578C20.8803 6.73246 20.4834 6.62796 20.0791 6.62793Z" fill="#BC165D" />
    <path fillRule="evenodd" clipRule="evenodd" d="M21.6244 15.681C21.6244 15.681 22.3283 11.1838 19.4458 9.23077C19.3591 10.7938 18.661 12.243 17.5262 13.2154C16.2934 14.3874 13.9758 17.0211 14.0004 19.8297C13.9839 22.279 15.1011 24.4444 17.2735 25.6314C19.4458 26.8184 21.6244 27.0636 23.2683 25.9521C24.9121 24.8405 25.665 24.1654 25.9608 20.3511C26.2566 16.5367 24.8286 14.1243 23.6432 12.9517C23.1957 14.0322 22.5009 14.9716 21.6244 15.681Z" fill="#BC165D" />
    <path d="M28.841 36.3668C28.841 36.3668 31.5473 33.334 35.694 34.6406C36.4874 34.8886 31.7324 38.0304 28.841 36.3668Z" fill="#BC165D" />
    <path d="M22.5477 38.4253C22.5477 38.4253 25.5125 35.657 29.5253 37.3445C30.2932 37.6654 25.2788 40.3515 22.5477 38.4253Z" fill="#BC165D" />
    <path d="M26.8765 35.9755C26.8765 35.9755 28.0071 32.036 32.2949 31.3462C33.1145 31.2125 30.1894 36.1702 26.8765 35.9755Z" fill="#BC165D" />
    <path d="M32.4044 33.7251C32.4044 33.7251 33.9443 29.9333 38.2795 29.7215C39.1083 29.679 35.6771 34.285 32.4044 33.7251Z" fill="#BC165D" />
    <path d="M11.159 36.3668C11.159 36.3668 8.4527 33.334 4.30603 34.6406C3.51265 34.8886 8.26757 38.0304 11.159 36.3668Z" fill="#BC165D" />
    <path d="M17.4523 38.4253C17.4523 38.4253 14.4875 35.657 10.4747 37.3445C9.70677 37.6654 14.7212 40.3515 17.4523 38.4253Z" fill="#BC165D" />
    <path d="M13.1235 35.9755C13.1235 35.9755 11.9929 32.036 7.70506 31.3462C6.88553 31.2125 9.81062 36.1702 13.1235 35.9755Z" fill="#BC165D" />
    <path d="M7.59557 33.7251C7.59557 33.7251 6.05567 29.9333 1.72046 29.7215C0.891681 29.679 4.32292 34.285 7.59557 33.7251Z" fill="#BC165D" />
  </svg>
);

export const SoloTeamTimeCard = ({
  mode = constants.SOLO_TIME,
  teamRound = 1,
  talkMoves = null,
  timer,
  timerValue,
  explanation,
  showHint,
  collaborationTip,
  prepareToShare,
  bubbleTop = null,
}) => {
  const isSoloMode = mode === constants.SOLO_TIME;
  const [showTeamTips, setShowTeamTips] = useState(false);
  const [showPrepareContent, setShowPrepareContent] = useState(false);
  const contentRef = useRef(null);
  const [bubbleReserve, setBubbleReserve] = useState(0);

  // Where the content scrolls (tablet), pad its end by the height the open
  // bubble covers, so it only overflows once text actually reaches the bubble
  // and every line can still be scrolled clear of it.
  useLayoutEffect(() => {
    const content = contentRef.current;
    const update = () => {
      if (!content || bubbleTop == null || window.getComputedStyle(content).overflowY !== "auto") {
        setBubbleReserve(0);
        return;
      }
      setBubbleReserve(Math.max(0, Math.ceil(content.getBoundingClientRect().bottom - bubbleTop)));
    };
    update();
    if (!content || typeof ResizeObserver === "undefined") return undefined;
    // Border box: the reserve's own padding doesn't change it, so no feedback loop.
    const observer = new ResizeObserver(update);
    observer.observe(content, { box: "border-box" });
    return () => observer.disconnect();
  }, [bubbleTop]);

  useEffect(() => {
    if (prepareToShare) {
      setShowPrepareContent(false);
      const timeout = setTimeout(() => {
        setShowPrepareContent(true);
      }, 600);
      return () => clearTimeout(timeout);
    } else {
      setShowPrepareContent(false);
    }
  }, [prepareToShare]);

  const soloItems = [
    {
      icon: sentimentNeutralIcon,
      boldText: "No talking!",
      text: "Tackle this problem by yourself."
    },
    {
      icon: checkCircleIcon,
      boldText: "Pick your answer!",
      text: "Don't worry about making mistakes!"
    },
    {
      icon: commentsIcon,
      boldText: "Get Ready!",
      text: "What ideas and questions will you share with the group?"
    }
  ];

  const currentColor = isSoloMode ? colors.blue500 : colors.pink800;
  const titleColor = isSoloMode ? colors.blue800 : colors.pink800;

  return (
    <CardContainer data-testid="side-panel-card">
      <PhaseHeader $team={!isSoloMode}>
        <PhaseArt $src={isSoloMode ? soloFilledIcon : talkFilledIcon} $color={titleColor} aria-hidden="true" />
        <PhaseTitle $color={titleColor}>
          <span>{isSoloMode ? "Solo Time" : "Team Time"}</span>
          {!isSoloMode && <RoundLabel>Round {teamRound}</RoundLabel>}
        </PhaseTitle>
      </PhaseHeader>

      {timerValue ? timer : <PhaseDivider $color={currentColor} />}

      <ContentSection ref={contentRef} data-testid="side-panel-content" prepareToShare={prepareToShare} $reserve={bubbleReserve}>
        {!isSoloMode && !showHint && (
          <TeamSection>
            {collaborationTip ? (
              <GoalRow $align="flex-start">
                <LevelUpTipIcon />
                <GoalText>
                  <GoalTitle>Your Teamwork Tip!</GoalTitle>
                  <span>{collaborationTip}</span>
                </GoalText>
              </GoalRow>
            ) : (
              <GoalRow
                $align="center"
                onMouseEnter={() => setShowTeamTips(true)}
                onMouseLeave={() => setShowTeamTips(false)}
              >
                <img src={targetIcon} alt="" width={40} height={40} />
                <GoalText>
                  <GoalTitle>Reach Teamwork Level 4!</GoalTitle>
                  <span>Help everyone talk through the problem together.</span>
                </GoalText>
                <RubricButton
                  type="button"
                  aria-label="Show teamwork rubric"
                  aria-expanded={showTeamTips}
                  aria-controls="teamwork-rubric"
                  onFocus={() => setShowTeamTips(true)}
                  onBlur={() => setShowTeamTips(false)}
                  onClick={() => setShowTeamTips((prev) => !prev)}
                  onKeyDown={(e) => {
                    if (e.key === "Escape") setShowTeamTips(false);
                  }}
                >
                  <img src={infoIcon} alt="" />
                </RubricButton>

                {showTeamTips && (
                  <RubricHoverWidget id="teamwork-rubric" role="status" aria-live="polite" aria-atomic="true" aria-label="OKO teamwork rubric">
                    <RubricTitle>Our OKO Teamwork Scores:</RubricTitle>
                    <RubricLevel>
                      <span><span aria-hidden="true">&#11088;&#11088;&#11088;&#11088; </span>Level 4 - Dream Team:</span> We build on each other's ideas or disagree respectfully. If a teammate is stuck, we help them until EVERYONE understands and can explain the why!
                    </RubricLevel>
                    <RubricLevel>
                      <span><span aria-hidden="true">&#11088;&#11088;&#11088; </span>Level 3 - Big Leagues:</span> We have great math talk! We are explaining the why and debating the answer, but not everyone in the group is talking.
                    </RubricLevel>
                    <RubricLevel>
                      <span><span aria-hidden="true">&#11088;&#11088; </span>Level 2 - Practice Squad:</span> There is some math talk, but most of us are just listening or agreeing without explaining our own thinking.
                    </RubricLevel>
                    <RubricLevel>
                      <span><span aria-hidden="true">&#11088; </span>Level 1 - Free Agents:</span> We are working by ourselves, just guessing, or being disruptive.
                    </RubricLevel>
                  </RubricHoverWidget>
                )}
              </GoalRow>
            )}
            {talkMoves && (
              <TalkMoveBlock>
                <strong>Try some talk moves:</strong>
                <ul aria-label="Talk moves">
                  {talkMoves.map(({ label, text }) => (
                    <li key={label}>
                      <strong>{label}:</strong> “{text}”
                    </li>
                  ))}
                </ul>
              </TalkMoveBlock>
            )}
          </TeamSection>
        )}
        {showHint && explanation && (
          <HintBox data-testid="side-panel-hint" $maxHeight={timerValue ? 334 : 370}>
            <p>HINT:<br />{Array.isArray(explanation) ? explanation.join(' ') : explanation}</p>
          </HintBox>
        )}
        {isSoloMode && !prepareToShare && (
          <ItemsList>
            {soloItems.map((item, index) => (
              <ListItem key={index}>
                <IconMask iconSrc={item.icon} primaryColor={currentColor} />
                <ItemText primaryColor={currentColor}>
                  <strong>{item?.boldText}</strong> {item.text}
                </ItemText>
              </ListItem>
            ))}
          </ItemsList>
        )}
        {isSoloMode && prepareToShare && showPrepareContent && (
          <PrepareToShareSection style={{
            animation: "slideInBounce 0.9s ease-out forwards"
          }}>
            <ListItem>
              <img src={writeDownIcon} alt="write down" style={{ width: 40, height: 40, flexShrink: 0 }} />
              <PrepareToShareHeader>
                <strong>Prepare to Share</strong>
                <span>Write a thought or question you have.</span>
              </PrepareToShareHeader>
            </ListItem>
            <PreparePrompts>
              <PreparePromptBlock>
                <strong>If you're on a roll:</strong>
                <ul>
                  <li>"My first step was..."</li>
                  <li>"I think it's ___ because..."</li>
                </ul>
              </PreparePromptBlock>
              <PreparePromptBlock>
                <strong>If you need a hand:</strong>
                <ul>
                  <li>"I got stuck when..."</li>
                  <li>"I'm wondering about..."</li>
                </ul>
              </PreparePromptBlock>
            </PreparePrompts>
          </PrepareToShareSection>
        )}
      </ContentSection>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  background: white;
  border-radius: 16px;
  /* A fixed width, so the card doesn't follow its content (e.g. collapsing
     while Prepare to Share waits to slide in). */
  width: 330px;
  max-width: 330px;
  min-height: 486px;
  margin: 0 auto;

  /* Tablet heights (768px) can't fit the desktop minimum plus the bottom-anchored
     OKO bot; the card fills its bounded region and only the content below the
     header scrolls (see ContentSection). */
  @media ${constants.TABLET_MEDIA_QUERY} {
    min-height: auto;
    height: 100%;
    overflow: hidden;
  }
  font-family: Inter, sans-serif;
  position: relative;
  display: flex;
  flex-direction: column;

  @keyframes slideInBounce {
    0% {
      transform: translateX(50%);
      opacity: 0;
    }
    30% {
      transform: translateX(-4%);
      opacity: 1;
    }
    45% {
      transform: translateX(3%);
      opacity: 1;
    }
    60% {
      transform: translateX(-2%);
      opacity: 1;
    }
    73% {
      transform: translateX(1.5%);
      opacity: 1;
    }
    85% {
      transform: translateX(-0.8%);
      opacity: 1;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  flex: 1;
  overflow: ${props => props.prepareToShare ? 'hidden' : 'visible'};

  @media ${constants.TABLET_MEDIA_QUERY} {
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: ${({ $reserve }) => 16 + $reserve}px;

    /* A visible thumb — iOS hides overlay scrollbars until touched, which
       makes the clipped content look like all there is. */
    scrollbar-width: thin;
    scrollbar-color: ${colors.milkGlass800} transparent;
    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-thumb { background: ${colors.milkGlass800}; border-radius: 3px; }
  }
`;

const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const IconMask = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background-color: ${props => props.primaryColor};
  mask: url(${props => props.iconSrc}) no-repeat center;
  mask-size: contain;
  -webkit-mask: url(${props => props.iconSrc}) no-repeat center;
  -webkit-mask-size: contain;
`;

const ItemText = styled.div`
  font-size: 14px;
  color: ${props => props.primaryColor};
  margin: 0;
  line-height: 20px;
  flex: 1;
  font-weight: 400;

  strong {
    font-weight: 700;
  }
`;

const PrepareToShareSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 6px 0;
`;

const PrepareToShareHeader = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.blue500};
  font-size: 14px;
  line-height: 20px;

  strong {
    font-weight: 700;
  }
`;

const PreparePrompts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PreparePromptBlock = styled.div`
  font-size: 14px;
  color: ${colors.blue500};
  line-height: 20px;

  strong {
    font-weight: 700;
  }

  ul {
    margin: 4px 0 0 0;
    padding-left: 16px;
    list-style-type: disc;
  }

  li {
    margin-bottom: 4px;
  }
`;

const RubricHoverWidget = styled.div`
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  background: ${colors.blue100};
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 20px;
  width: 340px;
  z-index: 1000;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* Tablet: the card clips its content (only the content area scrolls), so the
     flyout escapes via fixed positioning, pinned just right of the 360px column. */
  @media ${constants.TABLET_MEDIA_QUERY} {
    position: fixed;
    left: 368px;
    top: 50%;
    margin-left: 0;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -8px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid ${colors.blue100};
  }
`;

const RubricTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  color: ${colors.nightlyWoods950};
`;

const RubricLevel = styled.p`
  font-size: 13px;
  margin: 0;
  color: ${colors.nightlyWoods950};
  line-height: 1.4;

  > span {
    font-weight: 700;
  }
`;

/* Desktop: the card grows with its content and nothing scrolls it, so a long
   hint is capped to the card's content area and scrolls inside. Tablet: the
   whole content area already scrolls. The cap stays on the hint rather than
   the content area so the rubric flyout outside the card isn't clipped. */
const HintBox = styled.div`
  background: ${colors.pink50};
  border-radius: 12px;
  padding: 18px;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.nightlyWoods950};
  max-height: ${({ $maxHeight }) => $maxHeight}px;
  overflow-y: auto;

  @media ${constants.TABLET_MEDIA_QUERY} {
    max-height: none;
    overflow-y: visible;
  }
`;

const PhaseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: ${({ $team }) => ($team ? "0" : "8px")};
  height: ${({ $team }) => ($team ? "80px" : "72px")};
  padding: 16px;
  background: ${({ $team }) => ($team ? colors.pink50 : colors.blue50)};
  border-radius: 16px 16px 0 0;
`;

const PhaseArt = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  background-color: ${({ $color }) => $color};
  mask: url(${({ $src }) => $src}) no-repeat center;
  mask-size: contain;
  -webkit-mask: url(${({ $src }) => $src}) no-repeat center;
  -webkit-mask-size: contain;
`;

const PhaseTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  white-space: nowrap;
  color: ${({ $color }) => $color};
  font-family: "ABC Marfa", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

const RoundLabel = styled.span`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.25px;
`;

const PhaseDivider = styled.div`
  height: 4px;
  flex-shrink: 0;
  background: ${({ $color }) => $color};
`;

const TeamSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${colors.pink800};
  font-size: 14px;
  line-height: 20px;
`;

const GoalRow = styled.div`
  display: flex;
  align-items: ${({ $align }) => $align};
  gap: 8px;
  position: relative;

  > img,
  > svg {
    flex-shrink: 0;
  }
`;

const GoalText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const GoalTitle = styled.strong`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.25px;
`;

const RubricButton = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

const TalkMoveBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;

  strong {
    font-weight: 700;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;
